import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { trackPromise } from 'react-promise-tracker';
// import { alertActions } from '_store';
import { fetchWrapper } from '_utils';

// Create slice

const name = 'uploadDC';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const slice = createSlice({ name, initialState, reducers });

// Exports

export const uploadDcActions = { ...slice.actions, ...extraActions };
export const uploadDcReducer = slice.reducer;

// Implementation

function createInitialState() {
    return {
        fileData: null,
        uploadStatus: null,
        errorMessage: null,
        isUploading: false
    };
}

function createReducers() {
    return {
        setUploadStatus,
        clearUpload
    };

    function setUploadStatus(state, action) {
        state.uploadStatus = action.payload.status;
        state.fileData = action.payload.data;
        state.isUploading = false;
        state.errorMessage = null;
    }

    function clearUpload(state) {
        state.fileData = null;
        state.uploadStatus = null;
        state.isUploading = false;
        state.errorMessage = null;
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_MARKETER_API_URL}/api`;


    return {
        uploadDc: uploadDc(),
        uploadDcData: uploadDcData()
    };

    function uploadDc() {
      return createAsyncThunk(
        `${name}/uploadDc`,
        async (payload, { rejectWithValue }) => {
          try {
            const response = await trackPromise(
              fetchWrapper.post(`${baseUrl}/DCNomintionUpload/upload`, {
                Data: payload,
              }),
            );
            return response;
          } catch (error) {
            return rejectWithValue(error);
          }
        },
      );
    }

    function uploadDcData() {
      return createAsyncThunk(
        `${name}/uploadDc`,
        async (payload, { rejectWithValue }) => {
          try {
            const response = await trackPromise(
              fetchWrapper.post(`${baseUrl}/Marketer/UploadAccountAllocation`, {
                Data: payload,
              }),
            );
            return response;
          } catch (error) {
            return rejectWithValue(error);
          }
        },
      );
    }

}
